import styled from 'styled-components';
import { useState } from 'react';

import { Checkbox } from 'shared/components/Checkbox';
import { SizeFilterProductType } from 'search/components/searchGrid/SearchFilterSizeMobileProductType';
import { sortSizeTitles, transformSizeFacet } from 'search/utils/sizeFilterUtils';
import { t } from 'localization/utils/t';

const TP = 'search.components.searchGrid.SearchFilterSizeMobile';

export const SearchFilterSizeMobile = ({
  facet,
  selectedFilterValues,
  setSelectedFilterValues,
  isTransformed,
}) => {
  const transformedSizes = isTransformed ? facet : transformSizeFacet(facet.options);
  const [showSizeConversions, setShowSizeConversions] = useState(true);

  const handleSetShowSizeConversionsChange = () => {
    setShowSizeConversions((prevState) => !prevState);
  };

  const sizes = isTransformed
    ? Object.keys(transformedSizes).sort(sortSizeTitles)
    : Object.keys(transformedSizes);

  return (
    <>
      <SearchFilterSizeMobile.Checkbox
        data-qa="show_size_conversions_checkbox"
        checked={showSizeConversions}
        id="show_size_conversions"
        label={t(`${TP}.showSizeConversions`, 'Show size conversions')}
        labelStyle={{ fontSize: '11px' }}
        name="showSizeConversions"
        onChange={handleSetShowSizeConversionsChange}
        value={showSizeConversions.toString()}
      />
      {sizes.map((productType) => (
        <SizeFilterProductType
          key={productType}
          productType={productType}
          selectedFilterValues={selectedFilterValues}
          setSelectedFilterValues={setSelectedFilterValues}
          sizeOptions={{ ...transformedSizes[productType] }}
          showSizeConversions={showSizeConversions}
        />
      ))}
    </>
  );
};

SearchFilterSizeMobile.Checkbox = styled(Checkbox)`
  flex-direction: row-reverse;
  justify-content: start;
  margin-bottom: 16px;
  > span {
    margin-right: 8px;
  }
`;
